import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useAlert } from '../hooks/useAlert';
import { useConfirm } from '../hooks/useConfirm';
import AlertModal from '../components/ui/AlertModal';
import ConfirmModal from '../components/ui/ConfirmModal';
import { theme } from '../styles/theme';

// Components
import DashboardSidebar from '../components/dashboard/DashboardSidebar';
import DashboardOrders from '../components/dashboard/DashboardOrders';
import DashboardAddresses from '../components/dashboard/DashboardAddresses';
import DashboardTracked from '../components/dashboard/DashboardTracked';
import DashboardProfile from '../components/dashboard/DashboardProfile';
import DashboardPassword from '../components/dashboard/DashboardPassword';
import DashboardResale from '../components/dashboard/DashboardResale';

const CustomerDashboard = () => {
  const { userProfile } = useAuth();
  const { alertState, showSuccess, showError, closeAlert } = useAlert();
  const { confirmState, showConfirm, handleCancel, handleConfirm } = useConfirm();
  const [activeTab, setActiveTab] = useState('orders');

  const renderContent = () => {
    const props = {
      showSuccess,
      showError,
      showConfirm,
    };

    switch (activeTab) {
      case 'orders':
        return <DashboardOrders {...props} />;
      case 'tracked':
        return <DashboardTracked {...props} />;
      case 'addresses':
        return <DashboardAddresses {...props} />;
      case 'account':
        return <DashboardProfile {...props} />;
      case 'password':
        return <DashboardPassword {...props} />;
      case 'resale':
        return <DashboardResale {...props} />;
      default:
        return <DashboardOrders {...props} />;
    }
  };

  const styles = {
    container: {
      minHeight: '100vh',
      backgroundColor: theme.colors.surface,
      padding: theme.spacing.lg,
    },
    layout: {
      display: 'grid',
      gridTemplateColumns: '280px 1fr',
      gap: theme.spacing.xl,
      maxWidth: '1400px',
      margin: '0 auto',
    },
    content: {
      minHeight: '400px',
    },
  };

  const responsiveStyles = `
    @media (max-width: 768px) {
      .dashboard-layout-responsive {
        grid-template-columns: 1fr !important;
        gap: ${theme.spacing.md} !important;
        padding: ${theme.spacing.sm} !important;
      }
      
      .dashboard-container-responsive {
        padding: ${theme.spacing.sm} !important;
      }
    }
    
    @media (min-width: 769px) and (max-width: 1024px) {
      .dashboard-layout-responsive {
        grid-template-columns: 240px 1fr !important;
        gap: ${theme.spacing.lg} !important;
      }
    }
  `;

  return (
    <>
      <style>{responsiveStyles}</style>
      <div className="dashboard-container-responsive" style={styles.container}>
        <AlertModal
          isOpen={alertState.isOpen}
          onClose={closeAlert}
          title={alertState.title}
          message={alertState.message}
          type={alertState.type}
        />
        
        <ConfirmModal
          isOpen={confirmState.isOpen}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
          title={confirmState.title}
          message={confirmState.message}
          type={confirmState.type}
          confirmText={confirmState.confirmText}
          cancelText={confirmState.cancelText}
        />
        
        <div className="dashboard-layout-responsive" style={styles.layout}>
          <DashboardSidebar 
            activeTab={activeTab} 
            setActiveTab={setActiveTab} 
            userProfile={userProfile} 
          />
          
          <main style={styles.content}>
            {renderContent()}
          </main>
        </div>
      </div>
    </>
  );
};

export default CustomerDashboard;
